import React from 'react';

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

export type RoundIconBtnProps = {
  // @NOTE: you can add more types here if need it
  icon: 'add_circle';
  children: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const RoundIconBtn = React.forwardRef<HTMLButtonElement, RoundIconBtnProps>(
  ({icon, children, onClick, ...props}, ref) => {
    return (
      <Button
        ref={ref}
        color="primary"
        startIcon={<Icon>{icon}</Icon>}
        variant="outlined"
        size="small"
        onClick={onClick}
        {...props}>
        {children}
      </Button>
    );
  }
);
